import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PageHero from '../components/PageHero';
import './ContactPage.css';
import './CMSContent.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);
  const [content, setContent] = useState('');
  const [title, setTitle] = useState('Contact Us');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPageContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/pages/contact`);
        setTitle(response.data.title);
        setContent(response.data.content);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching contact page:', error);
        setLoading(false);
      }
    };

    fetchPageContent();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // TODO: Implement contact form submission to backend
    console.log('Form submitted:', formData);
    setSubmitStatus('success');

    // Reset form
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  if (loading) {
    return <div className="page-loading">Loading...</div>;
  }

  return (
    <div className="contact-page">
      <PageHero title={title.toUpperCase()} />

      {content && (
        <div className="cms-content-section" dangerouslySetInnerHTML={{ __html: content }} />
      )}

      <div className="contact-container">
        <div className="contact-intro">
          <h2>WE WOULD LOVE TO HEAR FROM YOU! SEND US A MESSAGE OR FIND US ON SOCIAL MEDIA.</h2>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-info-section">
              <h2>EMAIL</h2>
              <p><a href="mailto:info@wtf-wear.com">info@wtf-wear.com</a></p>
            </div>

            <div className="contact-info-section">
              <h2>SOCIAL</h2>
              <ul className="social-links">
                <li>
                  <a href="https://www.facebook.com/wtfwearcom" target="_blank" rel="noopener noreferrer">
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@WTF-Wear" target="_blank" rel="noopener noreferrer">
                    YouTube
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="contact-form-wrapper">
            <h2>SIGN UP FORM</h2>
            <h3>THE FOLLOWING INFO IS REQUIRED</h3>

            {submitStatus === 'success' && (
              <div className="form-message success">
                Thank you for your message! We'll get back to you soon.
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <p>
                <label>
                  YOUR NAME<br />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </label>
              </p>

              <p>
                <label>
                  YOUR EMAIL<br />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </label>
              </p>

              <p>
                <label>
                  SUBJECT<br />
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </label>
              </p>

              <p>
                <label>
                  YOUR MESSAGE (OPTIONAL)<br />
                  <textarea
                    name="message"
                    rows="10"
                    cols="40"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </label>
              </p>

              <p>
                <button type="submit" className="submit-button">
                  Send Message
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
